import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import { WOW } from 'wowjs';
import 'animate.css';

const services = [
  { img: '/images/resource/service1-1.jpg', title: 'Restaurant & Bar', icon: 'fal fa-utensils', desc: 'World-class dining experience with international and local cuisine.' },
  { img: '/images/resource/service1-2.jpg', title: 'Spa & Wellness', icon: 'fal fa-spa', desc: 'Rejuvenate body and mind with our luxurious spa treatments.' },
  { img: '/images/resource/service1-3.jpg', title: 'Swimming Pool', icon: 'fal fa-swimming-pool', desc: 'Outdoor heated pool open year-round for guests.' },
  { img: '/images/resource/service1-1.jpg', title: 'Fitness Center', icon: 'fal fa-dumbbell', desc: 'State-of-the-art gym equipment with personal trainers.' },
  { img: '/images/resource/service1-2.jpg', title: 'Conference Rooms', icon: 'fal fa-briefcase', desc: 'Modern conference facilities for business events.' },
  { img: '/images/resource/service1-3.jpg', title: 'Airport Transfer', icon: 'fal fa-car', desc: 'Complimentary shuttle service to and from the airport.' },
];

export default function Services() {
  useEffect(() => {
    const wow = new WOW({ mobile: false, live: true });
    wow.init();
  }, []);

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header style="two" />
      <PageTitle title="Services" breadcrumbs={[{ label: 'Pages', path: '#' }, { label: 'Services' }]} />

      <section className="services-section pt-120 pb-60">
        <div className="auto-container">
          <div className="sec-title text-center wow fadeInUp">
            <span className="sub-title">What We Offer</span>
            <h2>Premium Hotel Services</h2>
          </div>
          <div className="row">
            {services.map((s, i) => (
              <div key={i} className="service-block-three col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${(i % 3) * 200}ms`}>
                <div className="inner-box">
                  <figure className="image"><img src={s.img} alt={s.title} /></figure>
                  <div className="content-box" style={{ padding: '20px' }}>
                    <div className="icon-box" style={{ fontSize: 28, color: 'var(--theme-color1)', marginBottom: 10 }}>
                      <i className={s.icon}></i>
                    </div>
                    <h5 className="title"><Link to="/">{s.title}</Link></h5>
                    <p className="text">{s.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
